import { Injectable } from '@angular/core';
import { MsalService} from '@azure/msal-angular';
import { AppConfiguration } from 'shared/app-configuration';
import { Observable } from 'rxjs';
import { AuthenticationResult} from '@azure/msal-browser';
import { getMSAL_SCOPES } from './core.module';

@Injectable()
export class AuthService {
  private readonly idTokenKey: string = 'samplicity-id-token';
  private readonly accessTokenKey: string = 'samplicity-access-token';
  private _config: any = AppConfiguration.azureAADConfig;
  private interactionInProgress = false;

  constructor(
    private _msal: MsalService
  ) {}

  public isLoggedIn(): boolean {
    return this._msal.instance.getActiveAccount() != null;
  }

  public signout(): void {
    this._msal.logout();
  }

  public getUsername(): string | null {
    var profile: any = this._msal.instance.getActiveAccount()
    return profile.username || null;
  }

  public acquireToken(): Observable<AuthenticationResult> {
    var request = {
      scopes: [getMSAL_SCOPES().apiRead],
    };
    return this._msal.acquireTokenSilent(request);
  }
}



